import { Bedrag, Knop } from '@qc/ui';
import { toonBtwTarief, type BtwTarief } from '@qc/core';
import type { EvenementBeeld } from './useEvenement.js';

export interface MenuGoedkeuringProps {
  beeld: EvenementBeeld;
}

/**
 * Menu's die op goedkeuring wachten. Pas na goedkeuring staat een menu in de
 * kassa; tot die tijd kan de kraam niets verkopen.
 */
export function MenuGoedkeuring({ beeld }: MenuGoedkeuringProps) {
  if (beeld.menusTerGoedkeuring.length === 0) {
    return (
      <p className="text-tekst-zacht">
        Er wacht geen menu op goedkeuring. Zodra een kraam zijn kaart instuurt, staat hij hier.
      </p>
    );
  }

  return (
    <div className="grid gap-6">
      {beeld.menusTerGoedkeuring.map((menu) => {
        const onzeker = menu.items.filter((item) => item.onzeker);
        return (
          <section key={menu.menuId} className="rounded-tegel border border-rand bg-vlak p-6">
            <header className="mb-4 flex flex-wrap items-start justify-between gap-4">
              <div>
                <h2 className="text-xl font-bold">{menu.kraamnaam}</h2>
                <p className="text-tekst-zacht">
                  Versie {menu.versie} · {menu.items.length} producten
                </p>
              </div>
              <div className="flex gap-2">
                <Knop
                  nadruk="gewoon"
                  className="px-4 text-base"
                  onClick={() => void beeld.keurMenu(menu.menuId, false)}
                >
                  Terug naar de kraam
                </Knop>
                <Knop
                  nadruk="hoofd"
                  className="px-4 text-base"
                  onClick={() => void beeld.keurMenu(menu.menuId, true)}
                >
                  Goedkeuren
                </Knop>
              </div>
            </header>

            {onzeker.length > 0 && (
              <p className="mb-4 rounded-tegel bg-vlak-hoog p-4 text-waarschuwing">
                {onzeker.length === 1
                  ? 'Eén regel is niet zeker ingelezen. Controleer die extra.'
                  : `${onzeker.length} regels zijn niet zeker ingelezen. Controleer die extra.`}
              </p>
            )}

            <ul className="divide-y divide-rand">
              {menu.items.map((item) => (
                <li key={item.id} className="flex items-center justify-between gap-4 py-3">
                  <span className="min-w-0">
                    <span className="block truncate text-lg">
                      {item.naam}
                      {item.onzeker && (
                        <span className="ml-2 text-waarschuwing">· controleren</span>
                      )}
                    </span>
                    <span className="block text-base text-tekst-zacht">
                      {item.categorie} · BTW {toonBtwTarief(item.btw_tarief as BtwTarief)}
                      {item.bekers > 0 ? ' · met beker' : ''}
                    </span>
                  </span>
                  <Bedrag centen={item.prijs_cent} className="text-lg font-semibold" />
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}
